import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

const ticketTriageConfig = {
  id: 'ticketTriageStore',
  initialState: {
    initialized: false,
    actions: null,
    reason: null,
    viewReason: false,
    closureFields: null,
    fieldsData: {},
    closureFieldsData: {},
    formData: {},
    techGroupData: {},
    replyResponse: null,
    fieldsMeta: null,
    isFieldsApproved: false,
    isFieldsDisliked: false,
    isReplyDisliked: false,
    fieldsContext: null,
    baseFieldsData: null,
    baseTechGroupData: null,
    baseFormData: null
  },

  methods: (set, get) => ({
    setInitialized: (bool: boolean) => {
      set({
        initialized: bool
      });
    },
    setViewReason: (bool: boolean) => {
      set({
        viewReason: bool
      });
    },
    setActions: (data: any) => {
      set({
        actions: data
      });
    },
    setReason: (data: any) => {
      set({
        reason: data
      });
    },
    setClosureFields: (data: any) => {
      set({
        closureFields: data
      });
    },
    setFieldsData: (data: any) => {
      set({
        fieldsData: data
      });
    },

    setFormData: (data: any) => {
      set({
        formData: data
      });
    },

    setTechGroupData: (data: any) => {
      set({
        techGroupData: data
      });
    },
    setReplyResponse: (data: any) => {
      set({
        replyResponse: data
      });
    },

    setClosureFieldsData: (data: any) => {
      set({
        closureFieldsData: data
      });
    },

    setFieldsMeta: (data: any) => {
      set({
        fieldsMeta: data
      });
    },

    setIsFieldsApproved: (bool: boolean) => {
      set({
        isFieldsApproved: bool
      });
    },

    setIsFieldsDisliked: (bool: boolean) => {
      set({
        isFieldsDisliked: bool
      });
    },

    setIsReplyDisliked: (bool: boolean) => {
      set({
        isReplyDisliked: bool
      });
    },

    setFieldsContext: (fieldsData) => {
      set({
        fieldsContext: fieldsData
      });
    },

    setBaseFieldsData: (data: any) => {
      set({
        baseFieldsData: data
      });
    },

    setBaseTechGroupData: (data: any) => {
      set({
        baseTechGroupData: data
      });
    },

    setBaseFormData: (data: any) => {
      set({
        baseFormData: data
      });
    },

    resetTicketTriageData: () => {
      set({
        initialized: false,
        actions: null,
        reason: null,
        viewReason: false,
        closureFields: null,
        fieldsData: {},
        formData: {},
        closureFieldsData: {},
        techGroupData: {},
        replyResponse: null,
        fieldsMeta: null,
        isFieldsApproved: false,
        isFieldsDisliked: false,
        isReplyDisliked: false,
        fieldsContext: null,
        baseFieldsData: null,
        baseTechGroupData: null,
        baseFormData: null
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useTicketTriageStore = createStore(ticketTriageConfig);
